// Escolhas das etapas de um item do carrinho do cardápio (popup: `order_steps`
// do produto + `step_selections` do cliente) no formato do pedido: `subitems`
// (o que a cozinha faz e o servidor confere preço) e `etapas` (resumo por etapa).
// Saiu de dentro do CheckoutModal (CardapioPublico.js) em 26/09/2026 pra o envio
// da Mesa QR usar a mesma regra — antes a rodada do QR ia sem as escolhas e o KDS
// mostrava o combo sem batata/bebida.

import { linhasDaEtapa } from "./precoEtapas";

export function resumoEtapasDoItem(item) {
  // Se ja vem pre-computado (ex: Refazer pedido copia direto do pedido original),
  // reusa sem tentar reconstruir via step_selections (que n existe nesse caminho).
  if (Array.isArray(item.etapas) && item.etapas.length > 0) return item.etapas;
  if (!item.step_selections || !item.order_steps) return [];
  const summary = [];
  // Índice ABSOLUTO como chave (v1.5.396) — mesma convenção do popup.
  const relevantSteps = item.order_steps
    .map((step, absIndex) => ({ ...step, _absIndex: absIndex }))
    .filter(step => {
      // combo_only só entra quando o item É combo de fato (v1.5.396) —
      // combo_type null/'simples' nunca leva etapas exclusivas do combo.
      if (step.combo_only) return item.combo_type === 'combo';
      return true;
    });
  relevantSteps.forEach((step) => {
    const selectedItems = item.step_selections[step._absIndex] || [];
    if (selectedItems.length > 0) {
      const itemNames = selectedItems.map(itemId => {
        const stepItem = step.items?.find(i => i.product_id === itemId);
        return stepItem?.product_name || '';
      }).filter(Boolean);
      if (itemNames.length > 0) {
        summary.push({ etapa: step.name, itens: itemNames });
      }
    }
  });
  return summary;
}

export function subitemsDoItem(item, allProducts = []) {
  // Se ja vem pre-computado (ex: Refazer pedido copia direto do pedido original),
  // reusa sem tentar reconstruir via step_selections (que n existe nesse caminho).
  if (Array.isArray(item.subitems) && item.subitems.length > 0) return item.subitems;
  if (!item.step_selections || !item.order_steps) return [];
  const subitems = [];
  // Índice ABSOLUTO como chave (v1.5.396) — mesma convenção do popup.
  const relevantSteps = item.order_steps
    .map((step, absIndex) => ({ ...step, _absIndex: absIndex }))
    .filter(step => {
      // combo_only só entra quando o item É combo de fato (v1.5.396) —
      // combo_type null/'simples' nunca leva etapas exclusivas do combo.
      if (step.combo_only) return item.combo_type === 'combo';
      return true;
    });
  relevantSteps.forEach((step) => {
    const selectedItems = item.step_selections[step._absIndex] || [];
    if (selectedItems.length === 0 || !step.items) return;
    // Consolidar duplicatas em quantidade
    const counts = {};
    const order = [];
    selectedItems.forEach(id => {
      if (counts[id] === undefined) order.push(id);
      counts[id] = (counts[id] || 0) + 1;
    });
    const linhas = [];
    order.forEach(itemId => {
      const stepItem = step.items.find(i => i.product_id === itemId);
      if (!stepItem) return;
      const qty = counts[itemId] || 1;
      // Quando step.sync_prices=true, usar SEMPRE o preco atual do produto (allProducts),
      // nao o snapshot estatico de step.items que pode ficar desatualizado quando o
      // lojista altera o preco do adicional na pagina de Produtos.
      const livePrice = (() => {
        const prod = (allProducts || []).find(p => p.id === stepItem.product_id);
        return prod ? Number(prod.sale_price || 0) : null;
      })();
      let preco;
      if (step.sync_prices !== false) {
        preco = livePrice !== null
          ? livePrice
          : Number(stepItem.sale_price ?? stepItem.price_override ?? 0);
      } else {
        // sync_prices=false: respeita o override configurado pelo lojista (0 = gratis)
        preco = stepItem.price_override === 0
          ? 0
          : Number(stepItem.price_override ?? stepItem.sale_price ?? livePrice ?? 0);
      }
      linhas.push({ stepItem, preco, qtd: qty });
    });
    // Preço de cada linha conforme o tipo da etapa (Soma, Máximo, Subtração):
    // a soma das linhas é o que a etapa acrescenta ou abate no item.
    const precos = linhasDaEtapa(step, linhas);
    linhas.forEach((linha, i) => {
      subitems.push({
        product_id: linha.stepItem.product_id,
        nome: linha.stepItem.product_name,
        preco: precos[i],
        quantidade: linha.qtd,
        step_name: step.name
      });
    });
  });
  return subitems;
}
